import type { Client } from '@core/generated/gql-types';
import {
  createFieldFilterConfig,
  type FilterConfig,
} from '@/components/filters';

export type ClientFilterConfig = FilterConfig<Client>;

const FIELD_FILTER_CONFIG = [
  createFieldFilterConfig<Client>('status', 'Status', 'status'),
  createFieldFilterConfig<Client>('suburb', 'Suburb', 'address.suburb'),
  createFieldFilterConfig<Client>('state', 'State', 'address.state'),
  createFieldFilterConfig<Client>('postcode', 'Postcode', 'address.postcode'),
  createFieldFilterConfig<Client>('chargeType', 'Charge Type', 'chargeType'),
];

const createSiteFilterConfig = (
  siteNamesByClientId: ReadonlyMap<string, readonly string[]>,
): ClientFilterConfig => ({
  key: 'site',
  title: 'Site',
  getOptions: (clients) =>
    Array.from(
      new Set(
        (clients || []).flatMap(
          (client) => siteNamesByClientId.get(client.id) ?? [],
        ),
      ),
    ).sort((left, right) => left.localeCompare(right)),
  getValueFromItem: (client) => [...(siteNamesByClientId.get(client.id) ?? [])],
});

export const createClientFilterConfig = (
  siteNamesByClientId: ReadonlyMap<string, readonly string[]>,
): ClientFilterConfig[] => [
  ...FIELD_FILTER_CONFIG,
  createSiteFilterConfig(siteNamesByClientId),
];

export const CLIENT_FILTER_KEYS = [
  ...FIELD_FILTER_CONFIG.map((filter) => filter.key),
  'site',
];
